export default "__VITE_ASSET__dcefceda__"